import { render, staticRenderFns } from "./EditableModelInfo.vue?vue&type=template&id=a42400a2"
import script from "./EditableModelInfo.vue?vue&type=script&lang=ts"
export * from "./EditableModelInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports